module.exports = __webpack_public_path__ + "img/turn-sharp-right.6ded2d49.svg";